import { render } from "./ChatMain.vue?vue&type=template&id=ef57a3be&scoped=true"
import script from "./ChatMain.vue?vue&type=script&lang=js"
export * from "./ChatMain.vue?vue&type=script&lang=js"

import "./ChatMain.vue?vue&type=style&index=0&id=ef57a3be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef57a3be"]])

export default __exports__